module.exports = __webpack_public_path__ + "static/media/phone.d565f5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 591
// module chunks = 0